import { ApolloLink, Observable } from "@apollo/client";
import { shouldSkipHttpProgress } from "@/lib/apollo/skip-http-progress-context";
import { decrementHttpRequests, incrementHttpRequests } from "@/lib/http-progress/http-progress-store";

/**
 * Tracks in-flight browser GraphQL operations for the global top progress bar.
 * Browser clients only — never wire this into the server Apollo client.
 *
 * Set `context: SKIP_HTTP_PROGRESS_CONTEXT` on background polls (e.g. notifications)
 * so silent refetches do not flash the top bar.
 */
export const progressLink = new ApolloLink((operation, forward) => {
    const trackProgress = !shouldSkipHttpProgress(operation.getContext());

    if (trackProgress) {
        incrementHttpRequests();
    }

    return new Observable((observer) => {
        let finalized = false;

        const finalize = () => {
            if (finalized) return;
            finalized = true;
            if (trackProgress) {
                decrementHttpRequests();
            }
        };

        const subscription = forward(operation).subscribe({
            next: (result) => observer.next(result),
            error: (error) => {
                finalize();
                observer.error(error);
            },
            complete: () => {
                finalize();
                observer.complete();
            },
        });

        return () => {
            finalize();
            subscription.unsubscribe();
        };
    });
});
